import ShaddowPuppets from "./ShadowPuppets";
import { instructionMap } from "./ShadowPuppetsData";
import { useEffect, useState } from "react";


  // const Level4 = [
  //   "Crocodile",
  //   "Dinosaur",
  //   "Wombat",
  //   "Pengunin",
  //   "Frilled Lizard",
  //   "Emu",
  //   "Dog",
  // ];
  //const Level1 = ["Dog", "Butterfly"];
  //const Level2 = ["Duck", "Dogs", "Crab", "Jellyfish", "Kookaburra", "Croc"];
  // const Level3 = ["Pelican", "Kangaroo", "Sea Tutle", "Sugar Glider", "Dingo"];

export default function Level6_ShadowPuppetsExpert(props) {
  const Level2 = ["Duck", "Dogs", "Crab", "Jellyfish", "Kookaburra", "Croc"];
    return (
      <ShaddowPuppets {...props} level={Level2} levelLabel="Level2" defaultImage="Duck"/>
    );
  }
  